export const stepperSteps: string[] = [
  `Add Photo`,
  `Required Info`,
  `Medical Info`,
]
